import {TextualDataBuilder} from './TextualDataBuilder'
import {DATA} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import
import type {Builder} from '@wix/document-services-types'

export class LinkBuilder extends TextualDataBuilder {
    constructor(displayName: string, defaultValue: string) {
        super('url', displayName, defaultValue)
    }

    toBuilderDataItem(): Builder.DataItem {
        return {
            ...super.toBuilderDataItem(),
            [DATA.DATA_TYPE.link]: {
                linkTypes: [DATA.LINK_TYPE.UNKNOWN_LinkType]
            }
        }
    }
}
